import { render, staticRenderFns } from "./Configx.vue?vue&type=template&id=30ae36fa"
import script from "./Configx.vue?vue&type=script&lang=js"
export * from "./Configx.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports